module.exports = {
  handle: (e, data) => {           
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
          event: `e.${data.eventName}Success`,
          productName: data.productName
      });      
  }
}